import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import { NotificationList } from 'src/app/_models';
import { AppConfig } from 'src/app/_helpers';

@Component({
  selector: 'app-notification-table',
  templateUrl: './notification-table.component.html',
  styleUrls: ['./notification-table.component.css', '../../../../assets/css/customer-list-table.css']
})
export class NotificationTableComponent implements OnInit, OnChanges {

  invNotificationListDataSource = new MatTableDataSource();
  displayedNotifyColumns: string[];
  pageSize: number;
  PageSizeOptions: number[];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() tableData: NotificationList[];
  @Input() tableHeaders: string[];
  @Input() notificationPropertiesDictionary;

  @Output() executeViewInvoiceNotDetails = new EventEmitter<string>();
  @Output() executeInvoiceGridActionClick = new EventEmitter<string[]>();

  constructor() {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {
    this.invNotificationListDataSource.sort = this.sort;
    this.invNotificationListDataSource.paginator = this.paginator;
  }

  ngOnChanges() {
    if (this.tableData !== undefined && this.tableHeaders !== undefined) {
      this.invNotificationListDataSource.data = this.tableData;
      this.displayedNotifyColumns = this.tableHeaders;
    }
  }

  viewInvoiceNotDetails(element: string) {
    this.executeViewInvoiceNotDetails.emit(element);
  }

  invoicegridActionClick(viewtype, publicid) {
    this.executeInvoiceGridActionClick.emit([viewtype, publicid]);
  }

  statusNameToSpanish(value) {
    if (this.notificationPropertiesDictionary != null) {
      const tempValue = this.notificationPropertiesDictionary.filter(data => data.value == value);
      if (tempValue.length > 0) {
        return tempValue[0].label;
      }
      return "";
    } else {
      return value;
    }
  }

}
